import { render, staticRenderFns } from "./reportePtiPresentados.vue?vue&type=template&id=8b3bdae2&scoped=true"
import script from "./reportePtiPresentados.vue?vue&type=script&lang=js"
export * from "./reportePtiPresentados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3bdae2",
  null
  
)

export default component.exports